import { TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA, SCROLL_USDC_ALLOWANCE_OWNER, SCROLL_USDC_ALLOWANCE_SPENDER, } from "../fixture-inputs.js";
// Native USDC on Scroll, issued directly by Circle.
const SCROLL_USDC = "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4";
export const SCROLL_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getBlockByNumberScroll",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getBalanceScroll",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: SCROLL_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getTokenBalanceScroll",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.scroll,
        fixture: "getBlockByHashScroll",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getBlockTransactionsScroll",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getTransfersScroll",
    },
    simulateCallQuery: {
        to: SCROLL_USDC,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "simulateCallScroll",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.scroll,
        fixture: "traceTransactionScroll",
    },
    tokenMetadataQuery: {
        address: SCROLL_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getTokenMetadataScroll",
    },
    tokenAllowanceQuery: {
        token: SCROLL_USDC,
        owner: SCROLL_USDC_ALLOWANCE_OWNER,
        spender: SCROLL_USDC_ALLOWANCE_SPENDER,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getTokenAllowanceScroll",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.scroll,
        fixture: "getReceiptScroll",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.scroll,
        fixture: "getTransactionByHashScroll",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasScroll",
    },
    codeQuery: {
        address: SCROLL_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.scroll,
        fixture: "getCodeScroll",
    },
    logsQuery: {
        // Scroll USDC — 50-block window for log density.
        address: SCROLL_USDC,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.scroll - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.scroll),
        fixture: "getLogsScroll",
    },
};
